import './App.css';
import Hero from './Components/Hero';
import Programs from './Components/Programs';
import Reasons from './Components/Reasons';
import Plans from './Components/Plans';
import Testimonials from './Components/Testimonials';
import Join from './Components/Join';
import Footer from './Components/Footer';
function App() {
  return (
    <div className="App">
      <Hero />
      <Programs />
      <Reasons />
      <Plans />
      <Testimonials />
      <Join />
      <Footer />
    </div>
  );
}

export default App;
